// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1IInk","vLegacy":"SelectSecondary_vLegacy__2TcZr","error":"SelectSecondary_error__2Ea2q","disabled":"SelectSecondary_disabled__3wF2j"};